import {
  Box,
  Button,
  Stack,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import FallbackImage from "assets/images/Fallback.svg";

const Fallback = () => {
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const getBody = () => {
    return (
      <main id="main-content" tabIndex={-1} style={{ outline: "none" }}>
        <Stack
          sx={{
            backgroundColor: "white",
            height: "100vh",
          }}
          alignItems="center"
          justifyContent="center"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 2,
            }}
          >
            <Box
              component="img"
              src={FallbackImage}
              alt="Error illustration showing something went wrong"
              sx={{
                height: "auto",
                maxWidth: "100%",
                width: 350,
              }}
            />
          </Box>
          <Typography
            component="h1"
            align="center"
            variant={mdUp ? "h1" : "h4"}
          >
            Sorry about that! Something went wrong.
          </Typography>
          <Typography
            align="center"
            color="text.secondary"
            sx={{ mt: 2, mx: 2 }}
          >
            Try reloading the page. If the problem persists, please contact our
            support team.
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 6,
            }}
          >
            <Button variant="contained" href={"/"}>
              Back to Home
            </Button>
          </Box>
        </Stack>
      </main>
    );
  };

  return getBody();
};

export default Fallback;
